import React, { useState } from 'react';
import { Modal, Form, Input, message, Button } from 'antd';
import leadReturnsService from '../services/leadReturns';

const ReturnRequestModal = ({ visible, onClose, purchase, onSuccess }) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const values = await form.validateFields();
      await leadReturnsService.requestReturn(purchase.id, values.return_reason);
      message.success('Return request submitted successfully');
      onSuccess(purchase.id);
      form.resetFields();
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to submit return request');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={isSubmitting}
      okText="Submit Request"
      footer={[
        <Button key="submit" type="primary" loading={isSubmitting} onClick={handleSubmit}>
          Submit Request
        </Button>,
      ]}

    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          name="return_reason"
          label="Reason for Return"
          rules={[
            { required: true, message: 'Please provide a reason for the return' },
            { min: 10, message: 'Reason must be at least 10 characters long' }
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Please explain why you want to return this lead..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReturnRequestModal; 